import { __rest, __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { useInputContext } from '../context/InputContext.js';
import styles from './TriggerButton.module.scss.js';

var TriggerButton = forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.position, position = _c === void 0 ? 'right' : _c, _d = _a.size, size = _d === void 0 ? 'm' : _d, variant = _a.variant, props = __rest(_a, ["children", "className", "position", "size", "variant"]);
    var inputContext = useInputContext();
    return (jsx("button", __assign({}, props, { className: clsx(styles.triggerButton, (_b = {},
            _b[styles.triggerButtonLeft] = position === 'left',
            _b[styles.triggerButtonRight] = position === 'right',
            _b[styles.triggerButtonError] = inputContext.hasError,
            _b[styles.triggerButtonWarning] = inputContext.hasWarning,
            _b[styles.triggerButtonDisabled] = inputContext.isDisabled,
            _b[styles.triggerButtonReadOnly] = inputContext.isReadOnly,
            _b[styles.triggerButtonMedium] = size === 'm',
            _b[styles.triggerButtonLarge] = size === 'l',
            _b[styles.triggerContained] = variant === 'contained',
            _b), className), disabled: inputContext.isDisabled, ref: ref, type: "button" }, { children: children })));
});

export { TriggerButton };
